import { render, staticRenderFns } from "./UserAddUser.vue?vue&type=template&id=cdcdfee4&scoped=true"
import script from "./UserAddUser.vue?vue&type=script&lang=js"
export * from "./UserAddUser.vue?vue&type=script&lang=js"
import style0 from "./UserAddUser.vue?vue&type=style&index=0&id=cdcdfee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcdfee4",
  null
  
)

export default component.exports